let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9OKo1")).then(() => parcelRequire('6jqdB'));